<template>
    <iv-form
        class="adm-filterbar"
        :model="conditions.values"
        :inline="inline"
        :label-position="labelPosition"
        :label-width="labelWidth">
        <slot name="before"></slot>
        <template
            v-for="fieldset in conditions.attrs">
            <iv-form-item
                :prop="fieldset.name"
                :key="fieldset.name"
                v-if="!fieldset.hidden">
                <iv-input
                    v-if="[Array,'Daterange','Date',Date,'Search','ButtonGroup'].indexOf(fieldset.type) == -1"
                    :value="conditions.values[fieldset.name]"
                    @input="onValueChanged($event, fieldset.name)"
                    :style="fieldset.style || {width: '200px'}"
                    @keypress.enter.native="$emit('search')">
                    <span slot="prepend">{{ fieldset.title || fieldset.name }}</span>
                </iv-input>
                <iv-button-group v-if="fieldset.type=='ButtonGroup'">
                    <iv-button
                        v-for="(item, index) in (fieldset.subs ? fieldset.subs : fieldset.options)"
                        :key="index"
                        :type="(fieldset.subs ? conditions.values[fieldset.name] == item.name : conditions.values[fieldset.name] == item.id) ? 'primary' : 'ghost'"
                        @click="onButtonGroupChanged(fieldset, item)">
                        <iv-icon v-if="item.icon" :type="item.icon" />
                        {{ item.title || item.name }}
                    </iv-button>
                </iv-button-group>
                <iv-input
                    v-if="['Search'].indexOf(fieldset.type) > -1"
                    :value="conditions.values[fieldset.search_by]"
                    @input="onValueChanged($event, fieldset.search_by)"
                    :style="fieldset.style || {width: '200px'}"
                    @keypress.enter.native="$emit('search')">
                    <span slot="prepend">
                        <span v-if="!fieldset.subs">{{ fieldset.title || fieldset.name }}</span>
                        <iv-select
                            v-else
                            :style="fieldset.search_by_style || {width: '80px'}"
                            v-model="fieldset.search_by"
                            @on-change="onSearchByChanged(fieldset)">
                            <iv-option class="text-left" v-for="(item,index) in fieldset.subs" :key="index" :label="item.title || item.name" :value="item.name">{{ item.title || item.name }}</iv-option>
                        </iv-select>
                    </span>
                </iv-input>
                <iv-select
                    v-if="[Array].indexOf(fieldset.type) > -1"
                    :value="conditions.values[fieldset.name]"
                    @input="onValueChanged($event, fieldset.name)"
                    :style="fieldset.style || {width: '120px'}"
                    :multiple="fieldset.multiple"
                    :placeholder="fieldset.placeholder"
                    :filterable="fieldset.filterable"
                    :clearable="fieldset.clearable">
                    <iv-option v-for="(item,index) in fieldset.options" :key="item.id+'-'+index" :label="item.label" :value="item.id">{{ item.name }}</iv-option>
                </iv-select>
                <iv-date-picker
                    v-if="['Daterange'].indexOf(fieldset.type) > -1"
                    :type="fieldset.hasTimer ? 'datetimerange' : 'daterange'"
                    :format="fieldset.format || 'yyyy-MM-dd'"
                    :placeholder="fieldset.placeholder"
                    :value="conditions.values[fieldset.name]"
                    @input="onValueChanged($event, conditions.values[fieldset.name]);onDaterangeChanged(fieldset)"
                    :style="fieldset.style || {width: fieldset.hasTimer ? '280px' : '200px'}" />
                <iv-date-picker
                    v-if="['Date', Date].indexOf(fieldset.type) > -1"
                    type="date"
                    :format="fieldset.format || 'yyyy-MM-dd'"
                    :placeholder="fieldset.placeholder"
                    :value="conditions.values[fieldset.name]"
                    @input="onValueChanged($event, fieldset.name)"
                    :style="fieldset.style || {width: '200px'}" />
            </iv-form-item>
        </template>
        <slot></slot>
    </iv-form>
</template>
<script>
import Fecha from "@/utils/type/Fecha"
const __defaults = (fields) => fields.reduce((result, fieldset)=>{
    if (['Search'].indexOf(fieldset.type) > -1) return result
    const fieldName = fieldset.name
    if(typeof fieldset.default === 'undefined'){
        result[fieldName] = typeof fieldset.type === "function" ? new fieldset.type : ""
    }else{
        result[fieldName] = fieldset.default;
    }
    return result
}, {})

const __serialize = (query, conditions)=>{
    const result = conditions.reduce((result, fieldset) => {
        const fieldName = fieldset.name
        if (typeof query[fieldName] === 'undefined' && fieldset.type != "Daterange") return result
        switch (typeof fieldset.type === 'function' ? fieldset.type.name : fieldset.type) {
            case 'Date':
                result[fieldName] = query[fieldName]
                break
            case 'Daterange':
                let val = query[fieldName] || [];
                if (typeof fieldset.subs === 'undefined') {
                    result[fieldName] = val
                } else {
                    result[fieldName] = fieldset.subs.map(subFieldName=>query[subFieldName]);
                }
                break
            case 'Search':
                // search作为组合UI设定固不解析
                break
            // default:
            //     result[fieldName] = fieldset.format ? fieldset.format(query[fieldName]) : query[fieldName];
            //     break
        }
        return result
    }, {})
    return { ...query, ...result}
}
export default {
    props: {
        value: Object,
        condition: Array,
        inline: {
            type: Boolean,
            default: true
        },
        labelPosition: {
            type: String,
            default: "right"
        },
        labelWidth: {
            type: Number,
            default: 0
        },
        Contype:String
    },
    beforeMount () {
        if(!!this.condition) this.mapCondition(this.condition)
    },
    data(){
        return {
            conditions: {
                attrs: this.condition || [],
                values: Object.assign(this.value, {...__defaults(this.condition), ...this.value}) || {}
            }
        }
    },
    watch: {
        value(val){
            const result = {...__defaults(this.conditions.attrs), ...__serialize(val, this.conditions.attrs) }
            this.conditions.values = Object.assign(result, val)
        },
        condition(val){
            this.mapCondition(val)
        }
    },
    methods: {
        mapCondition(val){
            // 格式化subs数据，转为对应的fiedlset
            this.conditions.attrs = val.map(fieldset=>{
                if(!!fieldset.subs && fieldset.subs.every(sub=>typeof sub == "string")){
                    fieldset.subs = fieldset.subs.map(fieldName=>this.conditions.attrs.find(fieldset=>fieldset.name==fieldName))
                }
                return fieldset
            })
            // 处理默认值
            this.conditions.attrs
                .filter(item=>[Array,"ButtonGroup"].indexOf(item.type))
                .filter(item=>!!item.subs)
                .forEach(item=>
                    item.subs
                        .filter(sub=>sub.name==this.conditions.values[item.name])
                        .forEach(sub=>this.onButtonGroupChanged(item, sub))
                )
            this.conditions.values = this.conditions.values
        },
        onButtonGroupChanged(fieldset, item){
            if(!!fieldset.subs){
                // fieldset.search_by = item.name
                // fieldset.subs.forEach(_fieldset=>_fieldset.hidden=_fieldset.name!=fieldset.search_by)
                this.conditions.values[fieldset.name] = item.name
                fieldset.subs.forEach(sub=>sub.hidden=sub.name!=item.name)
                this.onSearchByChanged(fieldset)
            }
            else this.conditions.values[fieldset.name] = item.id
        },
        onSearchByChanged(fieldset){
            // fieldset.subs.filter(_fieldset=>_fieldset.name!=fieldset.search_by).forEach(_fieldset=>this.conditions.values[_fieldset.name]='')
            fieldset.subs
                .filter(sub=>sub.name!=this.conditions.values[fieldset.name])
                .forEach(sub=>this.conditions.values[sub.name]='')
        },
        onDaterangeChanged(fieldset){
            if(typeof fieldset.subs === 'undefined') return
            this.$nextTick(()=>{
                // for (let index = 0; index < fieldset.subs.length; index++) {
                //     this.conditions.values[fieldset.subs[index]] = this.conditions.values[fieldset.name][index]
                // }
                fieldset.subs.forEach((index,sub_fieldset)=>this.conditions.values[sub_fieldset.name] = this.conditions.values[fieldset.name][index])
            })
        },
        onValueChanged(val, fieldName){
            this.conditions.values[fieldName] = val
            this.$emit('input', this.conditions.values)
        }
    },
    filters: {
        find(name, array=this.conditions.attrs){
            return array.find(attr=>attr.name===name)
        },
        display(obj, fields){
            return fields.reduce((result,field)=>result || obj[field], '')
        }
    }
}
</script>
